"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = void 0;
exports.events = {
    SHOW_MORE: '@actions/showMore',
    SHOW_LESS: '@actions/showLess',
    UPDATE_TERM: '@actions/updateTerm',
    CLEAR_TERM: '@actions/clearTerm'
};
//# sourceMappingURL=events.js.map